import { render, staticRenderFns } from "./complaintsDisposal.vue?vue&type=template&id=23a087c8&scoped=true"
import script from "./complaintsDisposal.vue?vue&type=script&lang=js"
export * from "./complaintsDisposal.vue?vue&type=script&lang=js"
import style0 from "./complaintsDisposal.vue?vue&type=style&index=0&id=23a087c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a087c8",
  null
  
)

export default component.exports